<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :loading="loading" @on-cancel="cancel"
           :width="650"
    >
      <h3 slot="header" class="modal-header">修改密码</h3>
      <div class="content">

        <Steps :current="current">
          <Step title="修改密码" content=""></Step>
          <!--<Step title="验证新手机号" content=""></Step>-->
          <Step title="完成" content=""></Step>
          <!--<Step title="步骤4"></Step>-->
        </Steps>

        <div v-if="current===0" style="margin-top: 40px;">
          <Form :model="formData" :label-width="100" ref="formData" label-position="left" :rules="formRules">
            <FormItem label="原始密码" prop="oldPass">
              <Input  type="password"   class="item-width" v-model="formData.oldPass" ></Input>
            </FormItem>
            <FormItem label="输入新密码" prop="newPass">
              <Input type="password"  class="item-width" v-model="formData.newPass" @on-change="changeOld"></Input>
              <!--<span class="error-color" :class="{block:newPassErr}"></span>-->

            </FormItem>
            <FormItem label="确认新密码" prop="newPassWord">
              <Input type="password" class="item-width" v-model="formData.newPassWord"></Input>
            </FormItem>
            <!--<div class="error-color" :class="{block:newPassWordErr}">确认密码与新密码不一致</div>-->
          </Form>
        </div>

        <div v-if="current===1" class="text-align-c" style="padding: 40px 0 ">
          重置密完成！
          <br>
          <br>

          恭喜您，您的密码已重置完成，请重新登录系统
        </div>

        <div class="text-align-c " style="margin-top: 40px">
          <Button type="primary" @click.stop="toStep2" v-if="current===0">下一步</Button>
          <Button type="primary" @click.stop="toStep3" v-if="current===1">确定</Button>
          <!--<Button type="primary" @click.stop="" v-if="current===2">确定</Button>-->
        </div>

      </div>


      <div slot="footer">
        <!--<Button type="error" size="large" long :loading="modal_loading" @click="del">Delete</Button>-->
      </div>

    </Modal>
  </div>

</template>
<script>
  import {changePassword} from "../../../../api/login";

  export default {
    name: ""   ,
    components:{
    },
    props:{
      n: {
        type: Number,
        default: 0
      },

    },
    watch:{
      n(){
        this.current = 0
        this.isShow=true
        this.formData.oldPass = ''
        this.formData.newPass = ''
        this.formData.newPassWord = ''
      }
    },
    data(){
      const validatenewPass = (require,value,callback) => {
        var numasc = 0;
        var charasc = 0;
        var charaasc = 0;
        var otherasc = 0;
        let message='密码由不少于8位且不含有用户名信息的大写字母、小写字母、数字和特殊字符组成 '
        if (0 == value.length) {
          callback(new Error(message))
        } else if (value.length < 8) {
          callback(new Error(message))
        } else {
          for (var i = 0; i < value.length; i++) {
            var asciiNumber = value.substr(i, 1).charCodeAt();
            if (asciiNumber >= 48 && asciiNumber <= 57) {
              numasc += 1;
            }
            if ((asciiNumber >= 65 && asciiNumber <= 90)) {
              charasc += 1;
            }
            if ((asciiNumber >= 97 && asciiNumber <= 122)) {
              charaasc += 1;
            }
            if ((asciiNumber >= 33 && asciiNumber <= 47) || (asciiNumber >= 58 && asciiNumber <= 64) || (asciiNumber >= 91 && asciiNumber <= 96) || (asciiNumber >= 123 && asciiNumber <= 126)) {
              otherasc += 1;
            }
          }
          if (0 == numasc) {
            callback(new Error(message))
          } else if (0 == charasc) {
            callback(new Error(message))
          } else if (0 == charaasc) {
            callback(new Error(message))
          } else if (0 == otherasc) {
            callback(new Error(message))
          } else {
            callback()
          }
        }
      }
      const validatenewPassWord = (require,value,callback) => {
        if(!(value+'')){
          callback(new Error(' '))
          return

        }
        if(value !== this.formData.newPass){
          callback(new Error(' '))
        }else{
          callback()
        }
      }
      return {
        current:0,
        loading: true,
        isShow:false,
        formData:{
          oldPass:'',
          newPass:'',
          newPassWord:'',
        },
        formRules:{
          oldPass:[{required: true,message:'原密码不能为空', type:'string',trigger:'blur'}],
          newPass: [{required: true, validator:validatenewPass,message: '密码由不少于8位且不含有用户名信息的大写字母、小写字母、数字和特殊字符组成',type:'string',trigger:'blur'}],
          newPassWord: [{required: true, validator:validatenewPassWord,message:'确认密码与新密码不一致',type:'string',trigger:'blur'}],
        },
      }
    },
    methods:{
      changeOld(){
        this.formData.newPassWord=''

      },
      toStep3(){
        // this.current=2
        this.isShow = false;
      },
      toStep2(){

        this.$refs['formData'].validate(bool=>{
          if(bool){
            let params = {
              oldPassword:this.formData.oldPass,
              newPassword:this.formData.newPass
            }
            changePassword(params).then( res => {
              this.current=1
            })

          }
          else {

          }

        })

      },
      ok(){

      },
      cancel(){

      }
    }

  }
</script>

<style scoped>
  .content{
    padding: 0 30px 30px 30px;
  }
  .error-color{
    position: absolute;
    bottom: 0;
    display: none;
  }
  .block {
    display: block;
  }

</style>
